export default __webpack_public_path__ + "static/media/stats.cf4cf8f3.png";